// Impostazioni dell'ambiente di sviluppo (siti IIS .DEV): usato dalla configurazione "dev".
export const environment = {
    production   : false,
    apiUrl       : 'https://stayinpuglia-api-dev.codefab.it',
    publicSiteUrl: 'https://stayinpuglia-dev.codefab.it',
    guestSiteUrl : 'https://stayinpuglia-guest-dev.codefab.it',
};
